export enum TicketEmailCase {
  EMAIL = 'email',
  SUBJECT = 'subject',
  MESSAGE = 'message',
}

export enum TicketEmailPlaceholder {
  YOUR_EMAIL = 'Your Email',
  EMAIL_SUBJECT = 'Email Subject',
  YOUR_MESSAGE = 'Your Message',
  SUBMIT = 'Submit',
}

export enum SupportNotificationAndConst {
  FLASH_NOTIFICATION_SUCCESS_MSG = 'Successfully sent email.',
  FLASH_NOTIFICATION_ERROR_MSG = 'Unable to send email, please try again later.',
  CLINICAL = 'clinical',
}